import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_3.png',
    createdAt: 1555016400000,
    email: 'ekaterina.tankova@touchandpay.me',
    name: 'Ekaterina Tankova',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_4.png',
    createdAt: 1555016400000,
    email: 'cao.yu@touchandpay.me',
    name: 'Cao Yu',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_2.png',
    createdAt: 1555016400000,
    email: 'alexa.richardson@touchandpay.me',
    name: 'Alexa Richardson',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_5.png',
    createdAt: 1554930000000,
    email: 'anje.keizer@touchandpay.me',
    name: 'Anje Keizer',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_6.png',
    createdAt: 1554757200000,
    email: 'clarke.gillebert@touchandpay.me',
    name: 'Clarke Gillebert',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_1.png',
    createdAt: 1554670800000,
    email: 'adam.denisov@touchandpay.me',
    name: 'Adam Denisov',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_7.png',
    createdAt: 1554325200000,
    email: 'ava.gregoraci@touchandpay.me',
    name: 'Ava Gregoraci',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_8.png',
    createdAt: 1523048400000,
    email: 'emilee.simchenko@touchandpay.me',
    name: 'Emilee Simchenko',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_9.png',
    createdAt: 1554702800000,
    email: 'kwak.seong.min@touchandpay.me',
    name: 'Kwak Seong-Min',
    phone: '09090209020'
  },
  {
    id: uuid(),
    address: {
      country: 'Nigeria',
      state: 'Lagos',
      city: 'Koshofe',
      street: '2 Walter Street'
    },
    avatarUrl: '/static/images/avatars/avatar_10.png',
    createdAt: 1522702800000,
    email: 'merrile.burgett@touchandpay.me',
    name: 'Merrile Burgett',
    phone: '801-301-7894'
  }
];
